import { ChangeEvent } from 'react';
import { Box, FormControlLabel } from '@material-ui/core';

import { LocationAndTeamsOption } from '@vyce/core/src/types';
import { AppCheckbox } from '@vyce/core/src/components/inputs';

import { useStyles } from '../styles';
import { InputProps } from '../types';

export const CheckboxItem = ({
  name,
  is_active,
  uuid,
  onChange,
}: LocationAndTeamsOption & { onChange: (event: ChangeEvent<HTMLInputElement>) => void }) => {
  const classes = useStyles();
  const inputProps: InputProps = { 'data-system-id': uuid };
  return (
    <Box key={uuid} marginTop="12px">
      <FormControlLabel
        classes={{ label: classes.label }}
        control={
          <AppCheckbox
            variant="rectangle"
            onChange={onChange}
            color="primary"
            checked={is_active}
            inputProps={inputProps}
          />
        }
        label={name}
      />
    </Box>
  );
};
